import { forwardRef } from "react";
import { cn } from "@/lib/utils";

const inputClass =
  "bg-background border border-input rounded-md px-3 py-2 text-[13px] text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background transition-colors";

export const SettingsInput = forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => (
  <input ref={ref} className={cn(inputClass, className)} {...props} />
));
SettingsInput.displayName = "SettingsInput";

export const labelClass = "text-[11.5px] font-medium text-muted-foreground mb-1.5";
